import { createSlice } from "@reduxjs/toolkit";
import { clearGuestSessionId, getOrCreateSessionId } from "../../util/session";

// guestSlice should always use getOrCreateSessionId when initializing, because its entire job is to track a guest session.
const initialState = {
  sessionId: localStorage.getItem("guest_session_id") || null,
};

const guestSlice = createSlice({
  name: "guest",
  initialState,
  reducers: {
    initGuestSession: (state) => {
      if (!state.sessionId) {
        state.sessionId = getOrCreateSessionId();
      }
    },
    clearGuestSession: (state) => {
      state.sessionId = null;
      clearGuestSessionId();
    },
  },
});

export const { initGuestSession, clearGuestSession } = guestSlice.actions;
export default guestSlice.reducer;
